import React, { memo, useCallback, useLayoutEffect, useMemo, useReducer } from 'react'
import { ReflexContainer, ReflexSplitter } from 'react-reflex'
import { useSelector } from 'react-redux'
import { graphStateHelper } from '../../../common/src/helpers'
import { OfficeSection } from './OfficeSection'
import { PMSection } from './PMSection'
import { actions } from './OfficeSplitViewActions'
import { initialState, panelKeys, reducer } from './OfficeSlitViewReducer'

const splitterStyle = {
  margin: '0px',
  borderTop: 'none',
  borderBottom: 'none',
  height: '1px',
  background: `${p => p.theme.palette.neutralTertiaryAlt}`,
}

export const OfficeSplitView = memo(
  ({
    items,
    selectedItem,
    graphItems,
    selectedGraphItem,
    onSelectItem,
    onSelectGraphItem,
    onCreateItem,
    onRenderLastItem,
    onRenderLastGraphItem,
    canBeEnabledOffice = true,
    loading = false,
    loadingGraph = false,
    PMFirst = true,
    placeholder,
    officePlaceholder,
    suggestedGraphPermissionLink,
    filterMode,
  }) => {
    const isGraphEnabled = useSelector(state => graphStateHelper.isGraphEnabled(state))
    const isEnabledOffice = isGraphEnabled && canBeEnabledOffice
    const [state, dispatch] = useReducer(reducer, { ...initialState })

    const panel = useMemo(() => {
      return PMFirst ? panelKeys.officePanel : panelKeys.pmPanel
    }, [PMFirst])

    const onToggleBottomSection = useCallback(() => {
      dispatch(actions.togglePanel(panel))
    }, [panel])

    useLayoutEffect(() => {
      const fn = isGraphEnabled ? actions.showPanel : actions.hidePanel
      dispatch(fn(panel))
    }, [isGraphEnabled, panel])

    const pmSection = (
      <PMSection
        items={items}
        selectedItem={selectedItem}
        onSelectItem={onSelectItem}
        onCreateItem={isEnabledOffice ? onCreateItem : undefined}
        onRenderLastItem={onRenderLastItem}
        loading={loading}
        placeholder={placeholder}
        canBeEnabledOffice={canBeEnabledOffice}
        isBottomView={!PMFirst}
        onToggleBottomSection={onToggleBottomSection}
        filterMode={filterMode}
        {...state.pmPanel}
      />
    )

    return (
      <ReflexContainer orientation="horizontal">
        {!!PMFirst && pmSection}
        {!!PMFirst && canBeEnabledOffice && <ReflexSplitter propagate style={splitterStyle} />}
        {canBeEnabledOffice && (
          <OfficeSection
            items={graphItems}
            selectedItem={selectedGraphItem}
            onSelectItem={onSelectGraphItem}
            onRenderLastItem={onRenderLastGraphItem}
            loading={loadingGraph}
            placeholder={officePlaceholder}
            onToggleBottomSection={onToggleBottomSection}
            isBottomView={!!PMFirst}
            graphPermissionLink={suggestedGraphPermissionLink}
            {...state.officePanel}
          />
        )}
        {!PMFirst && canBeEnabledOffice && <ReflexSplitter propagate style={splitterStyle} />}
        {!PMFirst && pmSection}
      </ReflexContainer>
    )
  }
)
